import { Badge } from "antd";
import { type TFunction } from "i18next";

import { ProgramAutomationTaskStatus } from "@fitness-app/data-models/entities/ProgramAutomation";

const statusMapper = {
  [ProgramAutomationTaskStatus.Upcoming]: "processing",
  [ProgramAutomationTaskStatus.Done]: "success",
  [ProgramAutomationTaskStatus.Rejected]: "error",
  [ProgramAutomationTaskStatus.Canceled]: "warning",
  // Nie było czego zrobić i to normalne (np. brak bieżącej edycji wyzwania) —
  // szary, żeby nie mylił się z błędem ani z odfiltrowaniem klientki.
  [ProgramAutomationTaskStatus.Skipped]: "default",
} as const;

/** Status zaplanowanego zadania w kalendarzu klientki — ten sam wygląd dla każdego typu zadania. */
export const automationTaskStatusBadge = (status: ProgramAutomationTaskStatus, t: TFunction) => (
  <Badge status={statusMapper[status] || "default"} text={t(`eventsStatus.${status || "upcoming"}`)} />
);
